import { Input, Directive } from '@angular/core';
import { Definition } from '../../data/definitions';

@Directive()
export abstract class DynamicAtom<T extends Definition> {
  @Input() definition!: T;
}
